export const formatInitialPrice = (price: string) => {
  if (!price) return '';
  return price.replace(/[^0-9]/g, '');
};